// extracted by mini-css-extract-plugin
export var chevron = "_jl-2";
export var dropdownItems = "_jl-0";
export var item = "_jl-1";